import { API_URL } from './config';

export const proService = {
    getRankings: async (gender: 'men' | 'women' = 'men') => {
        const res = await fetch(`${API_URL}/pro/rankings?gender=${gender}`);
        if (!res.ok) throw new Error("Failed to fetch rankings");
        return res.json();
    },
    getLiveScores: async () => {
        const res = await fetch(`${API_URL}/pro/live`);
        if (!res.ok) throw new Error("Failed to fetch live scores");
        return res.json();
    },
    getUpcomingTournaments: async () => {
        const res = await fetch(`${API_URL}/pro/tournaments`);
        if (!res.ok) throw new Error("Failed to fetch pro tournaments");
        return res.json();
    },
    getPastTournaments: async () => {
        const res = await fetch(`${API_URL}/pro/tournaments/past`);
        if (!res.ok) throw new Error("Failed to fetch past pro tournaments");
        return res.json();
    },
    getPlayerDetails: async (id: string) => {
        const res = await fetch(`${API_URL}/pro/player/${id}`);
        if (!res.ok) throw new Error("Failed to fetch player details");
        return res.json();
    },
    getTournamentVideos: async (id: string) => {
        const res = await fetch(`${API_URL}/pro/tournament/${id}/videos`);
        if (!res.ok) throw new Error("Failed to fetch tournament videos");
        return res.json();
    },
    getTournamentNews: async (id: string) => {
        const res = await fetch(`${API_URL}/pro/tournament/${id}/news`);
        if (!res.ok) throw new Error("Failed to fetch tournament news");
        return res.json();
    },
    claimProfile: async (proPlayerId: number, proofUrl: string) => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_URL}/pro/claim`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ pro_player_id: proPlayerId, proof_url: proofUrl })
        });
        if (!res.ok) {
            const err = await res.json() as any;
            throw new Error(err.error || "Failed to claim profile");
        }
        return res.json();
    },
    announceJoin: async (proPlayerId: number) => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_URL}/pro/announce-join`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ pro_player_id: proPlayerId })
        });
        if (!res.ok) {
            const err = await res.json() as any;
            throw new Error(err.error || "Failed to trigger announcement");
        }
        return res.json();
    }
};
